import { useEffect, useState } from "react";
import { PurchaseButton } from "./PurchaseButton";
import usePurchase from "@/hooks/usePurchase";

export default function Nav() {
  const { purchase, loading } = usePurchase();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <img
            src="https://customer-assets.emergentagent.com/job_day-trade-ebook-1/artifacts/9f44l5ze_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2011_26_30%20PM.png"
            alt="The 9-to-5 Exit Blueprint"
            className="h-12 md:h-14 w-auto object-contain transition-transform group-hover:scale-105"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8 text-sm text-white/60">
          <a href="#learn" className="hover:text-white transition">What You'll Learn</a>
          <a href="#inside" className="hover:text-white transition">Inside</a>
          <a href="#reviews" className="hover:text-white transition">Reviews</a>
          <a href="#pricing" className="hover:text-white transition">Pricing</a>
          <a href="#faq" className="hover:text-white transition">FAQ</a>
        </nav>

        <div className="hidden md:block">
          <PurchaseButton
            testId="nav-purchase-btn"
            onClick={() => purchase()}
            loading={loading}
            size="md"
            label="Purchase Now"
          />
        </div>
      </div>
    </header>
  );
}
